export default function Logo({ size = 'default', className = '' }) {
  const height = size === 'small' ? 72 : size === 'large' ? 200 : 100;
  return (
    <img
      src="/logo.png"
      alt="IJE HAUS LLC · Wholesale Distributor"
      data-testid="header-logo"
      className={className}
      style={{
        height,
        width: 'auto',
        display: 'block',
        userSelect: 'none',
        objectFit: 'contain',
      }}
      draggable="false"
    />
  );
}
